import { supabase } from './supabase';

const ADMIN_FN_URL = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/admin`;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

async function adminFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  const res = await fetch(`${ADMIN_FN_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(SUPABASE_ANON_KEY ? { apikey: SUPABASE_ANON_KEY } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const adminApi = {
  getStats: () => adminFetch('/stats'),
  getUsers: (params) => adminFetch(`/users?${new URLSearchParams(params)}`),
  disableUser: (userId) => adminFetch(`/users/${userId}/disable`, { method: 'POST' }),
  enableUser: (userId) => adminFetch(`/users/${userId}/enable`, { method: 'POST' }),
  deleteUser: (userId) => adminFetch(`/users/${userId}`, { method: 'DELETE' }),
  setUserRole: (userId, role) =>
    adminFetch(`/users/${userId}/role`, { method: 'POST', body: JSON.stringify({ role }) }),
  getWorkspaces: (params) => adminFetch(`/workspaces?${new URLSearchParams(params)}`),
  getWorkspaceDetail: (wsId) => adminFetch(`/workspaces/${wsId}`),
  deleteWorkspace: (wsId) => adminFetch(`/workspaces/${wsId}`, { method: 'DELETE' }),
  setWorkspacePlan: (wsId, payload) =>
    adminFetch(`/workspaces/${wsId}/plan`, { method: 'POST', body: JSON.stringify(payload) }),
  addWorkspaceMember: (wsId, payload) =>
    adminFetch(`/workspaces/${wsId}/members`, { method: 'POST', body: JSON.stringify(payload) }),
  setWorkspaceMemberRole: (wsId, userId, role) =>
    adminFetch(`/workspaces/${wsId}/members/${userId}/role`, {
      method: 'POST',
      body: JSON.stringify({ role }),
    }),
  removeWorkspaceMember: (wsId, userId) =>
    adminFetch(`/workspaces/${wsId}/members/${userId}`, { method: 'DELETE' }),
  getLinks: (params) => adminFetch(`/links?${new URLSearchParams(params)}`),
  disableLink: (linkId) => adminFetch(`/links/${linkId}/disable`, { method: 'POST' }),
  enableLink: (linkId) => adminFetch(`/links/${linkId}/enable`, { method: 'POST' }),
  getConfig: () => adminFetch('/config'),
  updateConfig: (data) => adminFetch('/config', { method: 'PUT', body: JSON.stringify(data) }),
};
